import { FormProvider } from 'react-hook-form';
import {
  OfferCodeInputLabels,
  OfferCodeInputVariables,
} from '@sparrow-card/sparrow-card-constants';
import Button from 'components/Button';
import { ButtonVariant } from 'components/Button/Button';
import {
  OFFER_CODE_EMAIL_OR_MAIL_OFFER,
  OfferCodeInput,
  REINSTATEMENT_OFFER_CODE_MASK_OPTIONS,
  REINSTATEMENT_OFFER_CODE_PLACEHOLDER,
  ZIP_CODE_PLACEHOLDER,
  ZIP_MASK_OPTIONS,
  ZipInput,
} from 'components/Input/templates';
import Loading from 'components/Loading';
import ValidationError from 'components/ValidationError';
import OfferCodeLayout from 'layout/OfferCodeLayout';
import { OFFER_CODE_ZIP_RULES } from 'pages/OfferCode/offerCodeZipRules';
import useReinstatementOfferForm from './useReinstatementOfferForm';
import styles from 'pages/OfferCode/OfferCode.module.scss';

const LAYOUT_TITLE = 'Welcome Back!\nReactivate Your Sparrow Card Today';
const LAYOUT_DESCRIPTION = 'To get started, please enter your Offer Code.';

const INPUTS_TO_MASKS_MAPPING = {
  [OfferCodeInputVariables.OfferCode]: REINSTATEMENT_OFFER_CODE_MASK_OPTIONS,
  [OfferCodeInputVariables.ZipCode]: ZIP_MASK_OPTIONS,
};

const ReinstatementOfferCode = () => {
  const {
    error,
    isInitialLoading,
    isLoading,
    isFormFilled,
    // eslint-disable-next-line @typescript-eslint/no-unused-vars -- kept out of FormProvider methods
    offerData,
    ...methods
  } = useReinstatementOfferForm(INPUTS_TO_MASKS_MAPPING);

  const { onSubmit, clearErrors } = methods;

  if (isInitialLoading) {
    return <Loading />;
  }

  return (
    <OfferCodeLayout description={LAYOUT_DESCRIPTION} title={LAYOUT_TITLE}>
      <FormProvider {...methods}>
        <form onSubmit={onSubmit} id="reinstatement-offer-code-form" noValidate>
          <div className={styles.inputsContainer}>
            <OfferCodeInput
              name={OfferCodeInputVariables.OfferCode}
              label={OfferCodeInputLabels.OfferCode}
              required
              placeholder={REINSTATEMENT_OFFER_CODE_PLACEHOLDER}
              maskOptions={REINSTATEMENT_OFFER_CODE_MASK_OPTIONS}
              containerClassName={styles.input}
              tooltipText={OFFER_CODE_EMAIL_OR_MAIL_OFFER}
            />
            <ZipInput
              name={OfferCodeInputVariables.ZipCode}
              label={OfferCodeInputLabels.ZipCode}
              required
              placeholder={ZIP_CODE_PLACEHOLDER}
              rules={OFFER_CODE_ZIP_RULES}
              externalOnChange={() => {
                clearErrors(OfferCodeInputVariables.ZipCode);
              }}
              containerClassName={styles.input}
            />
          </div>
          {!!error && (
            <ValidationError
              message={error}
              className={styles.offerCodeError}
              role="alert"
              aria-live="assertive"
            />
          )}
          <Button
            type="submit"
            title="Get started"
            variant={ButtonVariant.Gradient}
            className={styles.button}
            inactive={!isFormFilled}
            loading={isLoading}
          />
        </form>
      </FormProvider>
    </OfferCodeLayout>
  );
};

export default ReinstatementOfferCode;
